import { Injectable, EventEmitter } from '@angular/core';
import { User } from '@models/user';
import { ObservableObject } from '@models/observable-object';
import { Credentials } from '@models/credentials';
import { Cookie } from 'ng2-cookies/ng2-cookies';

/*Models */
import { Device } from '@models/device';

@Injectable()
export class CachedDataService {
  private token;
  private currentUser;
  private currentDeviceId;
  private currentDevice;
  private currentObject;
  public needUpdatePassword = false;
  private currentCredentials: Credentials;
  private observableObjects: ObservableObject[];
  private placeInfo = [];
  public isAuth = CachedDataService.isAuth;
  public updateUserStatus: EventEmitter<null> = new EventEmitter<null>();
  ifWatchAnotherUser = false;
  currentUserId: string;
  constructor() {

  }

  getObservableObjects() {
    if (this.observableObjects) {

      return this.observableObjects;
    }
    this.observableObjects = JSON.parse(localStorage.getItem('observableObjects'));
    return this.observableObjects;
  }

  setObservableObjects(observableObjects) {
    this.observableObjects = observableObjects;
    localStorage.setItem('observableObjects', JSON.stringify(observableObjects));
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
    this.token = token;
  }

  public getToken(): string {
    if (this.token) {
      return this.token;
    }
    this.token = localStorage.getItem('token');
    return this.token;
  }

  setCredentials(credentials: Credentials) {
    this.currentCredentials = credentials;
    this.currentCredentials.username = this.currentCredentials.username.replace(/\D/g, '')
    localStorage.setItem('credentials', JSON.stringify(this.currentCredentials));
  }
  setCurrentDeviceId(id: string) {

    // if(this.getCurrentDeviceId()){
    // 	if(this.getCurrentDeviceId()!=id){
    // 		this.clearSelectedGroupCommand()
    // 	}
    // }
    this.currentDeviceId = id;
    localStorage.setItem('currentDeviceId', id);
  }
  getCurrentDeviceId() {
    if (this.currentDeviceId) {
      return this.currentDeviceId;
    }
    return localStorage.getItem('currentDeviceId');
  }

  setCurrentDevice(device: Device) {
    this.currentDevice = device;
    localStorage.setItem('currentDevice', JSON.stringify(device));
  }

  getCurrentDevice() {
    if (this.currentDevice) {
      return this.currentDevice;
    } else {
      return JSON.parse(localStorage.getItem('currentDevice'));
    }
  }

  setCurrentObject(object: string) {
    this.currentObject = object;
    localStorage.setItem('currentObject', object);
  }
  getCurrentObject() {
    if (this.currentObject) {
      return JSON.parse(this.currentObject);
    }
    return JSON.parse(localStorage.getItem('currentObject'));
  }

  getCredentials(): Credentials {
    if (this.currentCredentials) {
      return this.currentCredentials;
    }

    const credentialsJson = localStorage.getItem('credentials');
    if (credentialsJson) {
      return JSON.parse(credentialsJson);
    }

    return null;
  }
  private static isAuth = (): boolean => CachedDataService.getUser();

  static getUser = (): any => {
    if (localStorage.getItem('currentUser') === null || localStorage.getItem('token') === null) {
      return false;
    } else {
      return true;
    }
  };
  getCurrentUser():User {
    if (this.currentUser) {
      return this.currentUser;
    }

    const currentUserJson = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(currentUserJson);
    return this.currentUser;
  }

  setCurrentUser(user: User) {
    this.currentUser = user;
    localStorage.setItem('currentUser', JSON.stringify(user));

  }
  setExpiredDate(remember: boolean) {
    let expire;
    if (remember) {
      expire = 7;
    } else {
      expire = 1;
    }
    Cookie.set('token-expire', 'true', expire, '/');
    this.updateUserStatus.emit();
  }
  getExpiredDate() {
    if (Cookie.get('token-expire')) {
      return true;
    } else {
      return false;
    }
  }
  setSelectedGroupCommand(saveGgroups: Array<any>) {
    localStorage.setItem('selectedGroupCommand', JSON.stringify(saveGgroups));
  }
  getSelectedGroupCommand() {
    const selectedGroupCommand = localStorage.getItem('selectedGroupCommand');
    return JSON.parse(selectedGroupCommand);
  }
  setCcode(code) {
    if (code) {
      localStorage.setItem('ccode', code);
    } else {
      localStorage.removeItem('ccode');
    }

  }
  getCcode() {
    return localStorage.getItem('ccode');
  }
  setPlaceInfo(item) {
    const currentPlaceInfo = this.getPlacesArray();


    let place;
    if (currentPlaceInfo) {
      this.placeInfo = JSON.parse(currentPlaceInfo);
    }

    if (this.placeInfo) {
      place = this.placeInfo.filter(place => place.lat == item.lat)[0];
      if (!place) {
        this.placeInfo.push(item);
      }
    } else {
      this.placeInfo.push(item);
    }


    localStorage.setItem('placeInfo', JSON.stringify(this.placeInfo));


  }
  getPlacesArray() {
    return localStorage.getItem('placeInfo');
  }
  getPlaceInfo(item) {
    const currentPlaceArray = JSON.parse(localStorage.getItem('placeInfo'));
    let currentPlace;
    if (currentPlaceArray) {
      currentPlace = currentPlaceArray.filter(place => (place.lat == item.lat && place.lng == item.lng))[0]
    }
    return currentPlace;

  }
  clearSelectedGroupCommand() {
    localStorage.removeItem('selectedGroupCommand');
  }
  // setPlaceAddres(){
  // 	localStorage.setItem('placeInfo', this.placeInfo);
  // }
  // getPlacesAddres(){
  // 	return localStorage.getItem('placeInfo');
  // }

  setTempUsername(value: string) {
    localStorage.setItem('tempUsername', value);
  }

  getTempUsername() {
    return localStorage.getItem('tempUsername');
  }
  clearTempUsername() {
    localStorage.removeItem('tempUsername');
  }

  clearCache() {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('observableObjects');
    localStorage.removeItem('credentials');
    localStorage.removeItem('expireddate');
    localStorage.removeItem('currentDeviceId');
    localStorage.removeItem('currentDevice');
    localStorage.removeItem('currentObject');
    localStorage.removeItem('tempUsername');
    //localStorage.removeItem('selectedGroupCommand');
    Cookie.delete('token-expire', '/');
    this.updateUserStatus.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/data/cached-data.service.ts